import type { FC } from 'react';
import { twMerge } from 'tailwind-merge';

import Typography from '@/components/typography';

type Props = {
  className?: string;
  index: number;
  content: string;
};

export const CardPill: FC<Props> = ({ className = '', index, content }) => {
  return (
    <div
      className={twMerge(
        'flex flex-row flex-nowrap items-center gap-2 rounded-full px-2 py-1',
        className
      )}
    >
      <Typography
        className="flex h-4 w-4 items-center justify-center rounded-full bg-black text-[12px] text-white"
        variant="button1"
      >
        {index}
      </Typography>
      <Typography variant="button1">{content}</Typography>
    </div>
  );
};
